import { Navigate, Route, Routes } from 'react-router-dom';
import { PerformanceDashboard } from 'pages/insights-pro/performance-tab/PerformanceDashboard';
import { PostingDatePerformanceReport } from 'pages/insights-pro/performance-tab/reports/PostingDatePerformanceReport';
import { DemandMonitoringReport } from 'pages/insights-pro/performance-tab/reports/demand-monitoring/DemandMonitoringReport';
import { DemandHome } from 'pages/insights-pro/performance-tab/reports/demand-monitoring/DemandHome';
import { DemandDetailPage } from 'pages/insights-pro/performance-tab/reports/demand-monitoring/DemandDetailPage';

export function PerformanceRoutes() {
  return (
    <Routes>
      <Route index element={<PerformanceDashboard />} />
      <Route path="reports/posting-date" element={<PostingDatePerformanceReport />} />
      <Route path="reports/demand-monitoring" element={<DemandMonitoringReport />}>
        <Route index element={<Navigate to={`home${location.search}`} replace />} />
        <Route path="home/*" element={<DemandHome />} />
        <Route path="detail/:attributeType/:attributeValue" element={<DemandDetailPage />} />
      </Route>
    </Routes>
  );
}
